module.exports = __webpack_public_path__ + "media/05 Auld lang syne.551b2ed3.mp3";